import React, { memo, useCallback, useRef } from 'react';
import { ClassNames } from '@emotion/core';
import styled from '@emotion/styled';
import ThumbnailPicture from '@embed/components/common/ThumbnailPicture';
import { isFalsy } from '@embed/helpers';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import ThumbnailBody from './ThumbnailBody/PlaylistThumbnailBody';
import ThumbnailWrapper from './ThumbnailWrapper';
const Container = styled('div') `
  background-size: 400% 400%;
  background: linear-gradient(-90deg, #eee, #ccc);
  box-sizing: border-box;
  height: 100%;
  width: 100%;
`;
const ThumbnailContainer = styled('div') `
  background-image: none;
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  border: none !important;
  box-sizing: border-box;
  color: currentColor;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  opacity: 1;
  position: relative;
  text-align: initial;
  text-decoration: none;
  width: 100%;
  z-index: 1;

  &:hover {
    color: inherit;
    filter: contrast(115%);
    text-decoration: none;
    z-index: 1;
  }
`;
const memoShouldMemoize = (prev, next) => !(prev.hasAutoplay !== next.hasAutoplay ||
    prev.hasPlayingInPlayerOverlay !== next.hasPlayingInPlayerOverlay ||
    prev.isLarge !== next.isLarge);
export default memo((props) => {
    const { appContext, hasPlayingInPlayerOverlay, index, playlist, params, actions, isLarge, } = props;
    const { t } = useTranslation();
    const autoplayTimer = useRef(null);
    const isTouched = useRef(false);
    const linkRef = useRef(null);
    const onClick = useCallback((e) => {
        e.preventDefault();
        actions.showVideoPlayer({
            playlist,
            isOpen: true,
        });
    }, [actions, appContext, params, playlist]);
    const handleMouseLeave = useCallback(() => {
        // cancel mouse enter timeout if any
        if (autoplayTimer.current) {
            clearTimeout(autoplayTimer.current);
            autoplayTimer.current = null;
        }
    }, []);
    const isVideoPlaying = false;
    return (<ClassNames>
      {({ css }) => (<ThumbnailWrapper className={`cy-thumbnail scrollTo_${playlist.id}`} isLarge={isLarge} mode={params.mode}>
          <Container onTouchStart={() => {
                isTouched.current = true;
            }} onMouseLeave={handleMouseLeave}>
            <ThumbnailContainer className="cy-thumbnail-link" ref={linkRef} onClick={onClick}>
              <ThumbnailBody mode={params.mode} caption={playlist.name} hidePlayButton={isVideoPlaying} hideCaption={isFalsy(params.captions) || isVideoPlaying} delayCaption={2000} actions={actions} isLarge={isLarge}>
                {hasPlayingInPlayerOverlay && (<div css={css `
                      align-items: center;
                      backdrop-filter: blur(10px);
                      background: rgba(0, 0, 0, 0.5);
                      color: rgba(255, 255, 255, 0.5);
                      display: flex;
                      top: 0;
                      right: 0;
                      bottom: 0;
                      left: 0;
                      justify-content: center;
                      position: absolute;
                      text-align: center;
                      z-index: 3;
                    `}>
                    {t('Playing in picture in picture.')}
                  </div>)}
                <ThumbnailPicture alt={playlist.name || 'Firework playlist'} css={css `
                    height: 100% !important;
                    margin: 0 !important;
                    object-fit: cover !important;
                    position: absolute !important;
                    top: 0 !important;
                    left: 0 !important;
                    width: 100% !important;
                    z-index: -2 !important;
                    -webkit-transform: translate3d(0, 0, 0);
                  `} loading={index <= 3 ? 'eager' : 'lazy'} src={playlist.thumbnail_url}/>
              </ThumbnailBody>
            </ThumbnailContainer>
          </Container>
        </ThumbnailWrapper>)}
    </ClassNames>);
}, memoShouldMemoize);
